import React, { useState, useCallback, useEffect } from 'react'
import { Box, Typography, Icon, IconButton } from '@mui/material'
import AdxDropzone from 'components/reusable/AdxDropzone'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxButton from 'components/custom/AdxButton'

const RequestAttachmentUploader = ({
  setFieldValue,
  errorMessage = '',
  values,
  errors,
  errorResponse,
}) => {
  const [uploadState, setUploadState] = useState('PENDING')
  const [files, setFiles] = useState([])
  const [errFiles, setErrFiles] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (values.file) {
      if (values.file.length) {
        setUploadState('READY')
        setFiles(values.file)
      }
    }
  }, [values.file])

  const handleUpload = useCallback((acceptedFiles, fileRejections) => {
    // This function will be handled later with API call using axios.
    setUploadState('UPLOADING')

    if (fileRejections.length && !acceptedFiles.length) {
      setUploadState('NOT_READY')
      setFiles([])
      setErrFiles(fileRejections.map((file) => file))
      return
    }
    setFieldValue(
      'file',
      acceptedFiles?.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    )
    setFiles(
      acceptedFiles?.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    )
  }, [])

  const handleCancelUpload = () => {
    setFiles(null)
    setErrFiles([])
    setFieldValue('file', [])
    setUploadState('PENDING')
  }
  return (
    <Box display="flex" flexDirection="column" rowGap={1}>
      {uploadState === 'PENDING' ? (
        <AdxDropzone
          mainText="Upload Excel file"
          optionalText={`Upload file from your device or drag & drop here`}
          setUploadState={setUploadState}
          useDropzoneObject={{
            accept: ['.csv', 'application/vnd.ms-excel', 'text/csv', '.xlsx'],
            maxSize: 2097152,
            maxFiles: 1,
            onDrop: handleUpload,
          }}
        />
      ) : (
        <Box
          sx={{
            minWidth: '250px',
            minHeight: '350px',
            height: '100%',
            width: '100%',
            borderRadius: 4,
            border: '3px solid',
            borderColor: 'gray-line.main',

            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {uploadState === 'READY' ? (
            <>
              {files[0]?.type.includes('image') ? (
                <Box as="img" src={files[0].preview} width="100%" height="100%" borderRadius={4} />
              ) : (
                <Box
                  sx={{
                    backgroundColor: 'gray-background.main',
                    flex: 1,
                    width: '100%',
                    borderRadius: 4,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Icon
                    sx={{
                      fontSize: '5rem',
                      color: 'light-gray-text-2.main',
                    }}
                  >
                    file_copy
                  </Icon>
                </Box>
              )}
            </>
          ) : (
            <Box
              sx={{
                backgroundColor: 'gray-background.main',
                flex: 1,
                width: '100%',
                borderRadius: 4,
              }}
            />
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              p: 2,
            }}
          >
            {uploadState === 'NOT_READY'
              ? errFiles?.map(({ file, errors }, index) => (
                  <>
                    <Box
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                      columnGap={1}
                      key={index}
                    >
                      <Icon sx={{ color: 'error.main' }}>cancel</Icon>
                      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                        {file.name}
                      </Typography>
                    </Box>
                    <Typography variant="body2" color="error.main" key={index}>
                      {errors[0].message}
                    </Typography>
                    <IconButton onClick={handleCancelUpload}>
                      <Icon sx={{ color: 'error.main' }}>do_disturb_on</Icon>
                    </IconButton>
                  </>
                ))
              : files?.map((file, index) => (
                  <Box display="flex" flexDirection="column" rowGap={1} key={index}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                      {file.name}
                    </Typography>
                    <Typography variant="body2">{(file.size / 1000000).toFixed(1)} MB</Typography>
                  </Box>
                ))}

            {uploadState === 'READY' && (
              <Box display="flex" alignItems="center" columnGap={1}>
                {(errors.file || errorResponse) && !isLoading ? (
                  <>
                    <AdxButton variant={'ghost'} onClick={handleCancelUpload} size="small">
                      Replace
                    </AdxButton>

                    <IconButton onClick={handleCancelUpload}>
                      <Icon sx={{ color: 'error.main' }}>do_disturb_on</Icon>
                    </IconButton>
                  </>
                ) : null}
              </Box>
            )}
          </Box>
        </Box>
      )}
      {errorMessage && (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          minHeight="18px"
          mt={1}
        >
          <AdxErrorMessage errorMessage={errorMessage} />
        </Box>
      )}
    </Box>
  )
}

export default RequestAttachmentUploader
